
import { defineComponent, reactive, toRefs, watchEffect, computed } from 'vue'
import CExportFile from '@/components/c-export-file'
import { enterpriseViolationSettingQuery, gabCarQuery } from '../../api'
import { dropdownOfEnterprise } from '../../../transfer-application-review/api'
import moment from 'moment'

export default defineComponent({
  components: { CExportFile },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      formRef: null,
      loading: {
        company: false,
        setting: false,
        car: false
      },
      options: {
        company: [],
        setting: [],
        car: []
      },
      formData: {
        companyUuid: '',
        settingIds: [],
        carId: '',
        violationTimeStart: '',
        violationTimeEnd: ''
      },
      rules: {
        companyUuid: [{ required: true, message: '请选择企业名称', trigger: 'change' }]
      }
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    const exportParams = computed(() => {
      return {
        companyUuid: data.formData.companyUuid,
        settingIds: data.formData.settingIds,
        carId: data.formData.carId,
        violationTimeStart: data.formData.violationTimeStart ? moment(data.formData.violationTimeStart).format('YYYY-MM-DD 00:00:00') : '',
        violationTimeEnd: data.formData.violationTimeEnd ? moment(data.formData.violationTimeEnd).format('YYYY-MM-DD 23:59:59') : ''
      }
    })

    const remoteMethodCompany = (query: string) => {
      if (query) {
        data.loading.company = true
        dropdownOfEnterprise({ value: query }).then((res) => {
          data.options.company = res.data.map((item: any) => ({
            label: item.value,
            value: item.key
          }))
          data.loading.company = false
        })
      } else {
        data.options.company = []
      }
    }

    const remoteMethodSetting = (query: string) => {
      if (query) {
        data.loading.setting = true
        enterpriseViolationSettingQuery({ orgName: query }).then((res) => {
          data.options.setting = res.data.map((item: any) => ({
            label: item.orgName,
            value: item.id
          }))
          data.loading.setting = false
        })
      } else {
        data.options.setting = []
      }
    }

    const remoteMethodCar = (query: string) => {
      if (query) {
        data.loading.car = true
        gabCarQuery({ carNo: query }).then((res) => {
          data.options.car = res.data.map((item: any) => ({
            label: item.value,
            value: item.value
          }))
          data.loading.car = false
        })
      } else {
        data.options.car = []
      }
    }

    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
    }

    return {
      ...toRefs(data),
      formRef: data.formRef,
      rules: data.rules,
      onCancel,
      exportParams,
      remoteMethodCompany,
      remoteMethodSetting,
      remoteMethodCar
    }
  }
})
